import { takeLatest } from '@redux-saga/core/effects'
import { setProcedureLoaderItem } from '../store/timeline.actions'
import { put, select } from 'redux-saga/effects'
import { AirwayConstants } from '../../procedures/airway/store/airway.constants'
import { IntubationConstants } from '../../intubation/store/intubation.constants'
import { getPatientTimelineSelector } from '../selectors/patientTimeline.selector'
import { ITimelineState } from '../store/timeline.types'
import { ChildbirthOBConstants } from '../../procedures/childbirthOB/store/childbirthOB.constants'
import { InitiateIvConstants } from '../../procedures/initiateIv/store/initiateIv.constants'
import { ImmobilizationConstants } from '../../procedures/immobilization/store/immobilization.constants'
import { MedicalConsultConstants } from '../../procedures/medicalConsult/store/medicalConsult.constants'
import { RescueConstants } from '../../procedures/rescue/store/rescue.constants'
import { HospitalNotifyConstants } from '../../procedures/hospitalNotify/store/hospitalNotify.constants'
import { WoundCareConstants } from '../../procedures/woundCare/store/woundCare.constants'
import { AddMedicationAdministeredConstants } from '../../addMedicationAdministered/store/addMedicationAdministered.constants'
import { CardiacConstants } from '../../procedures/cardiac/store/cardiac.constants'
import { ImagingUltrasoundConstants } from '../../procedures/imagingUltrasound/store/imagingUltrasound.constants'
import { OperationsConstants } from '../../procedures/operations/store/operations.constants'
import { VentilatorConstants } from '../../procedures/ventilator/store/ventilator.constants'
import { ExtricationConstants } from '../../procedures/extrication/store/extrication.constants'
import { DrainConstants } from '../../procedures/drain/store/drain.constants'
import { TitrateConstants } from '../../procedures/titrate/store/titrate.constants'
import { LabsConstants } from '../../procedures/labs/store/labs.constants'
import { PnProcedureConstants } from '../../procedures/pnProcedure/store/pnProcedure.constants'
import { PnMedicationConstants } from '../../procedures/pnMedication/store/pnMedication.constants'
import { VitalsConstants } from '../../vitals/store/vitals.constants'
import { BloodProductAdministrationConstants } from '../../procedures/bloodProductAdministration/store/bloodProductAdministration.constants'
import { VentricularAssistDeviceConstants } from '../../procedures/ventricularAssistDevice/store/ventricularAssistDevice.constants'
import { CriticalCareConstants } from '../../procedures/criticalCare/store/criticalCare.constants'
import { AssessmentConstants } from '../../procedures/assessment/store/assessment.constant'

export function* setProcedureLoader() {
  const timelineState: ITimelineState = yield select(getPatientTimelineSelector)
  const { procedureLoader } = timelineState
  if (procedureLoader) {
    yield put(setProcedureLoaderItem(false))
  }
}

export function* setProcedureLoaderSaga() {
  yield takeLatest(
    [
      AddMedicationAdministeredConstants.SET_STATE,
      AirwayConstants.SET_STATE,
      CardiacConstants.SET_STATE,
      VentilatorConstants.SET_STATE,
      OperationsConstants.SET_STATE,
      IntubationConstants.SET_STATE,
      ChildbirthOBConstants.SET_STATE,
      InitiateIvConstants.SET_STATE,
      ImmobilizationConstants.SET_STATE,
      MedicalConsultConstants.SET_STATE,
      RescueConstants.SET_STATE,
      HospitalNotifyConstants.SET_STATE,
      WoundCareConstants.SET_STATE,
      ExtricationConstants.SET_STATE,
      ImagingUltrasoundConstants.SET_STATE,
      DrainConstants.SET_STATE,
      TitrateConstants.SET_TITRATE_STATE,
      LabsConstants.SET_STATE,
      PnProcedureConstants.SET_STATE,
      PnMedicationConstants.SET_STATE,
      VitalsConstants.SET_STATE,
      BloodProductAdministrationConstants.SET_STATE,
      VentricularAssistDeviceConstants.SET_STATE,
      CriticalCareConstants.SET_STATE,
      AssessmentConstants.SET_STATE,
    ],
    setProcedureLoader
  )
}
